
import * as defaultImport from "@splunk/react-ui/Message";
export * from "@splunk/react-ui/Message";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
